"use strict";

exports.__esModule = true;
exports.styleProxy = exports.customStyles = void 0;
/**
 * Remove the React-Select packaged CSS
 */

var styleProxy = exports.styleProxy = new Proxy({}, {
  get: function get(target, propKey) {
    return function () {};
  }
});
var customStyles = exports.customStyles = {
  clearIndicator: function clearIndicator() {
    return {};
  },
  container: function container() {
    return {};
  },
  control: function control() {
    return {};
  },
  dropdownIndicator: function dropdownIndicator() {
    return {};
  },
  group: function group() {
    return {};
  },
  groupHeading: function groupHeading() {
    return {};
  },
  indicatorsContainer: function indicatorsContainer() {
    return {};
  },
  indicatorSeparator: function indicatorSeparator() {
    return {};
  },
  input: function input() {
    return {};
  },
  loadingIndicator: function loadingIndicator() {
    return {};
  },
  loadingMessage: function loadingMessage() {
    return {};
  },
  // menu: () => ({}),
  // menuList: () => ({}),
  menuPortal: function menuPortal() {
    return {};
  },
  multiValue: function multiValue() {
    return {};
  },
  multiValueLabel: function multiValueLabel() {
    return {};
  },
  multiValueRemove: function multiValueRemove() {
    return {};
  },
  noOptionsMessage: function noOptionsMessage() {
    return {};
  },
  option: function option() {
    return {};
  },
  placeholder: function placeholder() {
    return {};
  },
  singleValue: function singleValue() {
    return {};
  },
  valueContainer: function valueContainer() {
    return {};
  }
};